// extracted by mini-css-extract-plugin
export default {"carouselContainer":"cardDekstopStyle_carouselContainer__JSR-8","textContainer":"cardDekstopStyle_textContainer__yaPHF","title":"cardDekstopStyle_title__-zsha"};